import styled from "@emotion/styled";
import { Section } from "../layout/section";
import { breakpoints } from "../../styles/breakpoints";

const StyledCampaign = styled.div`
  background-color: var(--off-white);
  text-align: center;
  padding: var(--large) var(--xx-small);

  @media(max-width: ${breakpoints.md}) {
    max-width: 600px;
    margin: auto;
  }

  div {
    max-width: 800px;
    margin: auto;
  }

  p {
    margin-top: var(--mini);
  }
`;

export const Campaign = () => (
  <section>
    <div className="row">
      <StyledCampaign>
        <div>
          <h2 className="h3">Effective SEO Campaigns</h2>
          <p>
            Don’t take our word for it. Check out this SEO case study showing a
            large chiropractic franchise that generated over 90,000 phone calls
            over nine months using our proprietary white label SEO services.
            This case study is based on 100+ locations and focused only on their
            Google Business Profile listings and rankings in the Maps sections
            on Google.
          </p>
        </div>
      </StyledCampaign>
    </div>
  </section>
);
